// Used to make accessing deep into our immutableJS map cleaner/clearer
export const DATA_MAP_PATHS = {
  bulkImportExternalId: 'bulkImportExternalId',
  courseGradeOverrideAction: 'courseGradeOverrideAction',
  courseGradeOverrideActionFormulaPath: [
    'courseGradeOverrideAction',
    'courseGradeOverrideAction',
    'definition',
    'formula',
  ],
  courseGradeOverrideActionGradePath: ['courseGradeOverrideAction', 'courseGradeOverrideAction', 'definition', 'grade'],
  courseGradeOverrideDelete: 'courseGradeOverrideDelete',
  courseGradeOverrideUpdate: 'courseGradeOverrideUpdate',
  email: 'email',
  gradedAssignmentGroupGradesPath: 'gradedAssignmentGroupGrades',
  itemGrades: 'itemGrades',
  itemLiveOutcomeGradePath: ['liveOutcome', 'grade'],
  itemOriginalOutcomeGradePath: ['originalOutcome', 'grade'],
  itemOutcomeOverrideAction: 'itemOutcomeOverrideAction',
  itemOutcomeOverrideActionGradePath: ['itemOutcomeActions', 'definition', 'grade'],
  itemOutcomeOverrideActions: 'itemOutcomeOverrideActions',
  itemOutcomeActions: 'itemOutcomeActions',
  itemOutcomeOverrideDelete: 'itemOutcomeOverrideDelete',
  itemOutcomeOverrideUpdate: 'itemOutcomeOverrideUpdate',
  itemOverrideOutcomeGradePath: ['overrideOutcome', 'grade'],
  liveCourseGradeOutcomePath: ['courseGrade', 'liveCourseOutcome', 'courseGrade'],
  originalCourseGradeOutcomePath: ['courseGrade', 'originalCourseOutcome', 'courseGrade'],
  overrideCourseGradeOutcomePath: ['courseGrade', 'overrideCourseOutcome', 'courseGrade'],
  overrideCourseGradeExplanationPath: ['courseGrade', 'overrideCourseOutcome', 'explanation'],
};

export default DATA_MAP_PATHS;
